import { useLocation } from "react-router-dom";
import SEOHead from "../seo/seo-header";
import Introduction from "./introduction";

function DeleteAccountPage() {
  const location = useLocation();
  const date = new Date();

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
  };
  const monthYear = date?.toLocaleDateString("en-US", options);

  const formattedDate = monthYear?.replace(" ", ", ");
  const DeleteData = {
    "@context": "https://schema.org",
    "@type": "DeleteAccountPage",
    name: "Delete Account",
    logo: "https://shiga.io/shiga-logo.png",
    description:
      "Contact us at shiga for inquiries, support, and feedback. Reach out to our team for assistance.",
    url: `https://www.shiga.io/${location?.pathname}`,
  };

  return (
    <>
      <SEOHead
        title="Delete Account - Shiga | Learn About Our Mission"
        description="Learn more about Shiga our mission to revolutionize financial services, and meet our founding team."
        structuredData={DeleteData}
        canonicalUrl={`https://www.shiga.io/${location?.pathname}`}
      />

      <div className="bg-[white] h-full w-full pb-[250px] md:pb-[350px]">
        <div className="w-full pt-[100px] pb-[60px] bg-[#E6E6FF99]/25">
          <h1 className="text-[36px] font-ibm text-center text-primary-main leading-[50px] tracking-normal font-bold md:text-[25px]">
            Delete Account
          </h1>
        </div>
        <div className="flex justify-center">
          <div className="max-w-[1300px] h-full pb-[50px]">
            <div className=" lg:px-6 xl:px-12 w-full h-full px-14 xlsm:px-3">
              <div className=" flex justify-center gap-[40px]">
                <div className="w-[800px] md:w-full h-full">
                  <div className="w-full">
                    <div className="mt-[40px] flex items-center gap-[8px]">
                      <p className="text-[#556987] text-[14px] leading-[30px] font-[600]  tracking-normal">
                        Before deleting your account, Kindly review the
                        following carefully.
                      </p>
                    </div>
                    <div className="mt-[20px] flex items-center gap-[8px]">
                      <div>
                        <img
                          src="/assets/calendar.svg"
                          alt="icon"
                          className="w-[20px] h-[20px]"
                        />
                      </div>
                      <p className="text-[#556987] text-[14px] leading-[30px] font-[600]  tracking-normal">
                        Last updated: {formattedDate}
                      </p>
                    </div>
                    <div id="introduction">
                      <Introduction />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeleteAccountPage;
